module.exports = __webpack_public_path__ + "img/shield-logo.6659e16a.png";